import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BusinessContact } from '../models/business-contact.model';

@Injectable()
export class ContactService {

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) {}

  /**
   * updates specified contact in api server
   * @param {number} businessID
   * @param {BusinessContact} contact
   * @return {Promise<any>}
   */
  putBusinessContact(businessID: number, contact: BusinessContact): Promise<any> {
    const URL = `${environment.airportsApiUrl}/business/${businessID}/contact/${contact.id}`;
    try {
      const BODY = this._getContactJSON(contact);
      return this._http.put(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * adds specified contact to server
   * @param {number} businessID
   * @param {BusinessContact} contact
   * @return {Promise<any>}
   */
  postBusinessContact(businessID: number, contact: BusinessContact): Promise<any> {
    const URL = `${environment.airportsApiUrl}/business/${businessID}/contact/`;
    try {
      const BODY = this._getContactJSON(contact);
      return this._http.post(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * deletes specified contact in api server.
   * @param {number} businessID
   * @param {number} contactID
   * @return {Promise<any>}
   */
  deleteBusinessContact(businessID: number, contactID: number): Promise<any> {
    const URL = `${environment.airportsApiUrl}/business/${businessID}/contact/${contactID}`;
    try {
      return this._http.delete(URL).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * converts business contact to json obj
   * @param {BusinessContact} contact
   * @return {any}
   * @private
   */
  _getContactJSON (contact: BusinessContact): any {
    return {
      contactName: contact.contactName,
      titleDept: contact.titleDept,
      phone: contact.phone,
      phoneType: contact.phoneType,
      email: contact.email,
      okToPublish: contact.okToPublish
    };
  }

}
